__turbopack_context__.v({
  "h1": "GdVuKq_h1",
  "h1Opt": "GdVuKq_h1Opt",
  "h2": "GdVuKq_h2",
  "h2Large": "GdVuKq_h2Large",
  "h2Opt": "GdVuKq_h2Opt",
  "h2Small": "GdVuKq_h2Small",
  "h3": "GdVuKq_h3",
  "larger": "GdVuKq_larger",
  "leftSideTextWrapper": "GdVuKq_leftSideTextWrapper",
  "p": "GdVuKq_p",
  "pBody": "GdVuKq_pBody",
  "pLarge": "GdVuKq_pLarge",
  "pLargeGradient": "GdVuKq_pLargeGradient",
  "pOpt": "GdVuKq_pOpt",
});
